<template>
	<div>
		<div class="u-stack-md">
			<CloLoadingAnimation v-if="loading" class="LoadingAnimation--basic" />
			<div v-if="list.length">
				<CloResultsGallery
					:list="list"
					dataFormat="search2.0"
					mediaVersion="2.0"
					integratedLightbox
					ratingEnabled
					:getRatingsUrl="getRatingsUrl"
					:saveRatingUrl="saveRatingUrl"
					:ratingCsrf="ratingCsrf"
					:mediaDownloadUrl="mediaDownloadUrl"
					class="u-stack-md"
					:responsiveImages="false"
				/>
				<a :href="mediaLink" class="Button Button--hollow Button--small u-stack-sm">
					{{ $t('hsinfo.moreTopMedia') }}
				</a>
			</div>

			<div v-if="error" class="GridFlex GridFlex--alignMiddle GridFlex--alignCenter u-inset-md">
				<div class="u-textCenter">
					<p class="u-text-3 u-margin-none">{{ $t('hsinfo.mediaUnavailable') }}</p>
				</div>
			</div>

			<div v-if="!loading && !error && !list.length" class="GridFlex GridFlex--alignMiddle GridFlex--alignCenter u-inset-md">
				<div class="u-textCenter">
					<p class="u-text-3 u-stack-sm">{{ $t('hsinfo.noMedia') }}</p>
					<a v-if="fallbackMediaLink" :href="fallbackMediaLink" class="Button Button--hollow Button--small u-stack-sm">
						{{ $t('index.latestMedia') }}
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import CloLoadingAnimation from '@/base/CloLoadingAnimation/CloLoadingAnimation';
import CloResultsGallery from '@/media/CloResultsGallery/CloResultsGallery';

export default {
	components: {
		CloLoadingAnimation,
		CloResultsGallery,
	},
	data() {
		return {
			list: [],
			loading: false,
			error: false,
		};
	},
	props: {
		url: {
			type: String,
			required: true,
		},
		getRatingsUrl: {
			type: String,
			required: true,
		},
		saveRatingUrl: {
			type: String,
			required: true,
		},
		ratingCsrf: {
			type: String,
			required: true,
		},
		mediaLink: {
			type: String,
			required: true,
		},
		mediaDownloadUrl: {
			type: String,
			required: true,
		},
		fallbackMediaLink: {
			type: String,
			default: null,
		},
	},
	mounted() {
		this.getMedia();
	},
	methods: {
		getMedia() {
			this.loading = true;
			axios
				.get(this.url)
				.then((res) => {
					this.list = res.data;
					this.loading = false;
					// need to remove data-asset-id attributes to not conflict with Lichen 1
					let count = 0;
					let timer = setInterval(() => {
						this.fixLichen();
						count++;
						if (count > 10) {
							clearInterval(timer);
						}
					}, 500);
				})
				.catch((err) => {
					console.log(err);
					this.error = true;
					this.loading = false;
				});
		},
		fixLichen() {
			const els = this.$el.querySelectorAll('[data-asset-id]');
			Array.prototype.forEach.call(els, (el) => {
				el.removeAttribute('data-asset-id');
			});
		},
	},
};
</script>

<style lang="scss">
// need to fix CSS for Lichen 1 and 2 conflicts
.Lightbox--dark {
	background-color: darken($color-black, 5%);
	.Button--close {
		background-color: $color-neutral-6;
	}
	.Lightbox-navigation {
		.Lightbox-previous,
		.Lightbox-next {
			background-color: $color-neutral-6;
		}
	}
	.Lightbox-caption {
		border: 0;
	}
}
.Lightbox-meta {
	background-color: transparent;
	border: 0;
}
.RatingStars .Icon--star {
	margin: 0;
}
// Target new lightbox to override a Lichen 1 style creeping in
.Lightbox--reverse {
	.Lightbox-carousel {
		position: static; // override Lichen 1 position absolute
	}
}
#place-main-content-sidebar {
	.SpectrogramPlayer--sm .SpectrogramPlayer-frame {
		height: unset;
	}
}
</style>
